import { motion, AnimatePresence } from "framer-motion";
import React from "react";

const variants = {
    enter: (direction: number) => ({
        x: direction > 0 ? 40 : -40,
        opacity: 0,
        position: "absolute",
    }),
    center: {
        x: 0,
        opacity: 1,
        position: "relative",
    },
    exit: (direction: number) => ({
        x: direction > 0 ? -40 : 40,
        opacity: 0,
        position: "absolute",
    }),
};

interface AnimatedContentProps {
    children: React.ReactNode;
    animationKey: string | number;
    direction: 1 | -1;
}

export function AnimatedContent({
                                    children,
                                    animationKey,
                                    direction,
                                }: AnimatedContentProps) {
    return (
        <div style={{ position: "relative", minHeight: "1em" }}>
            <AnimatePresence mode="popLayout" custom={direction}>
                <motion.div
                    key={animationKey}
                    custom={direction}
                    variants={variants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                    {children}
                </motion.div>
            </AnimatePresence>
        </div>
    );
}
